import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20hero%20background%2C%20dramatic%20manga%20style%20illustration%20with%20multiple%20characters%20in%20dynamic%20poses%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20floating%20particles%20and%20energy%20effects%2C%20clean%20composition%20with%20ample%20dark%20area%20for%20text%20overlay%2C%20rich%20orange%20gold%20black%20color%20palette&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="韩漫画网 - 免费韩国漫画在线阅读"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto text-center">
          <p className="text-accent-400 text-sm md:text-base font-medium mb-4 tracking-wider">
            韩国漫画网站大全 · 免费漫画在线阅读
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
            发现最精彩的
            <br />
            <span className="text-accent-400">韩国漫画</span>世界
          </h1>
          <p className="text-background-50/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            涵盖热血、恋爱、奇幻、悬疑等海量韩漫资源，每日更新，高清画质，完全免费。无论你是资深漫画迷还是新手入坑，这里都能找到你的最爱。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/action"
              className="bg-accent-500 text-background-50 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap hover:bg-accent-600 transition-all duration-300 cursor-pointer flex items-center gap-2"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/#popular"
              className="border border-background-50/30 text-background-50 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
            >
              热门推荐
            </Link>
          </div>

          <div className="mt-12 md:mt-16 flex items-center justify-center gap-8 md:gap-12">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">12,000+</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">从不间断</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">500万+</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">忠实读者</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}